'use strict';

/*@ngInject*/
module.exports = function unitsService($http) {

    this.getUnits = function () {
        return $http.get('units/getUnits');
    };

    this.getCountyList = function () {
        return $http.get('units/getCountyList');
    };

    this.getUnitChildren = function (parentCodes) {
        return $http.get('units/getUnitChildren?parentCodes=' + parentCodes.join());
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/units.service.js
 **/